<template>
	<section>
		<!--工具条-->
		<el-col :span="24" class="toolbar" style="padding-bottom: 0px;">
			<el-form :inline="true" :model="filters">
				<el-form-item>
					<!--<el-input v-model="filters.menuName" placeholder="主菜单名称"></el-input>-->

					<el-select v-model="filters.menuCode" clearable filterable placeholder="请选择菜单" >
					 <el-option    v-for="(item,index) in options" :key="index" :label="item.menu_name" :value="item.menu_code"></el-option>
                     </el-select>
				</el-form-item>

			
				<el-form-item>
					<el-button type="primary" v-on:click="getMenus">查询</el-button>
				</el-form-item>
				<el-form-item>
					<el-button type="primary" @click="handleAdd">新增</el-button>
				</el-form-item>
			</el-form>
		</el-col>

		<!--列表-->
		<el-table :data="menus" border stripe highlight-current-row v-loading="listLoading" @selection-change="selsChange" @sort-change="sortChange" style="width: 100%;"
		:header-row-style="{backgroundColor:'#eef1f6',lineHeight:'20px',color:'#000'}" :row-style="{height:'30px'}">
			<el-table-column type="selection" width="55">
			</el-table-column>
			<el-table-column type="index" label="编号"  width="80">
			</el-table-column>
			<el-table-column prop="menu_name" label="菜单名称" width="120">
			</el-table-column>
			<el-table-column prop="menu_code" label="菜单编号" width="100" >
			</el-table-column>
			<el-table-column prop="icon" label="图标"width="200"  >
			</el-table-column>
			<el-table-column  prop="path" label="路径" width="200" >		  
			</el-table-column>
			<el-table-column label="操作" >
				<template slot-scope="scope">
					<el-button size="small" @click="handleEdit(scope.$index, scope.row)">编辑</el-button>
					<el-button type="danger" size="small" @click="handleDel(scope.$index, scope.row)">删除</el-button>
				</template>
			</el-table-column>
		</el-table>

		<!--工具条-->
		<el-col :span="24" class="toolbar">
			<el-col :span="8"> <el-button type="danger" @click="batchRemove" :disabled="this.sels.length===0">批量删除</el-button></el-col>
			<el-col :span="8">
				<el-pagination @size-change="handleSizeChange"  @current-change="handleCurrentChange" :current-page="currentPage"
							:page-sizes="[20, 50, 80, 100]" :page-size="pageSize"  layout="total, sizes, prev, pager, next, jumper" :total="total" style="float:left;">
				</el-pagination>
			</el-col>
		</el-col>

		<!--编辑界面-->
		<el-dialog title="编辑" :visible.sync="editFormVisible" :close-on-click-modal="false"  size="tiny">
			<el-form :model="editForm"   label-width="100px" :rules="editFormRules" ref="editForm">
				<el-form-item label="上级菜单" prop="item_group">
					 <el-select v-model="editForm.parent_code"  placeholder="请选择" >
                        <el-option  v-for="(item,index) in parents" :key="index" :label="item.menu_name"  :value="item.menu_code"> </el-option>
                     </el-select>
				</el-form-item>
				<el-form-item label="菜单名称" prop="menu_name">
					<el-input v-model="editForm.menu_name" auto-complete="off" ></el-input>
				</el-form-item>
				<el-form-item label="菜单编号" prop="menu_code">
				     <el-input v-model="editForm.menu_code" auto-complete="off" ></el-input>
				</el-form-item>
				<el-form-item label="图标" prop="icon">
					 <el-input v-model="editForm.icon" auto-complete="off" ></el-input>
				</el-form-item>			
				<el-form-item label="路径" prop="path">					
					 <el-input v-model="editForm.path" auto-complete="off" ></el-input>
				</el-form-item>			
			</el-form>
			<div slot="footer" class="dialog-footer">
				<el-button @click.native="editFormVisible = false">取消</el-button>
				<el-button type="primary" @click.native="editSubmit" :loading="editLoading">提交</el-button>
			</div>
		</el-dialog>
	</section>
</template>

<script>
	//import util from '../../common/js/util'

	import { getMainMenuListPage,addMainMenu,editMainMenu, removeMainMenu,batchRemoveMainMenu,getParentMenu,getSysMenu } from '../../api/api';

 let CurrentUserID="",Session=""; 
	export default {
		data() {
			return {
				filters: {
					menuCode: ''
				},
				options:[],
				parents:[],
				menus: [],
				total: 0,
				pageSize:20,
				currentPage: 1,
				listLoading: false,
				sels: [],//列表选中列
                 prop:"", 
				 order:"",
				editFormVisible: false,//编辑界面是否显示
				editLoading: false,
				editFormRules: {
					menu_name: [
						{ required: true, message: '请输入菜单名', trigger: 'blur' }
					],
					menu_code: [
						{ required: true, message: '请输入菜单编码', trigger: 'blur' }
					]
				},
				//编辑界面数据
				editForm: {
					menu_id: 0,
					menu_name: '',
					menu_code: '',
					parent_code:'',
					icon:'',
					path: ''
				},

				formStatus: 0   //界面状态 0新增 1修改 2查看

			}
		},
		methods: {
			 handleSizeChange(val) {
				this.pageSize=val;                 
				this.getMenus();
             },		
			handleCurrentChange(val) {
				this.currentPage = val;
				this.getMenus();
			
			},

			getParent(){
             	 this.$http.jsonp(getParentMenu,{params: {CurrentUserID:CurrentUserID,systype:3,Session:Session }}).then(
		        	function(res){                         
					if (res.data.result_code==200)
					{						
						this.parents=res.data.parents;					
					}
					else{                           
						this.$message({
						message:'获取上级菜单错误',
						type: 'error'
						});
					}
				

					},
					function(res)
					{
						this.$message({
								message:'获取上级菜单错误',
								type: 'error'
								});
						
					});


			},
			//获取用户列表
			getMenus() {
				let para = {
				    CurrentUserID:CurrentUserID,
					currentPage: this.currentPage,
					pageSize:this.pageSize,
					menuCode: this.filters.menuCode,
					systype:3,
					sortName:this.prop,
					sortOrder:this.order,
					Session:Session
				};
				this.listLoading = true;
				

            this.$http.jsonp(getMainMenuListPage, {params: para}).then(
                   function(res){                         
                         if (res.data.result_code==200)
                         {
							 this.total = res.data.menulist.total;
					         this.menus = res.data.menulist.menus;
					         this.listLoading = false;
                           
                         }
                         else{                           
                              
                              this.listLoading = false;

							 if (res.data.result_code==911)
							  {
                                 this.$router.push({ path: "/login"});
								  return;
							  }

                              if (res.data.result_code==600)
							  {
									this.$message({
										message:'接口错误',
										type: 'error'
									});
                                  return;
							  }
							
                         }
                       

                   },
                   function(res)
                   {
                        this.$message({
                                message:'接口访问失败',
                                type: 'error'
                              });
                       this.listLoading = false;
                   }
           )






			},
			//删除
			handleDel: function (index, row) {
				this.$confirm('确认删除该记录吗?', '提示', {
					type: 'warning'
				}).then(() => {
					this.listLoading = true;
					//NProgress.start();
					let para = { CurrentUserID:CurrentUserID,menu_id: row.menu_id,sys_type:3,Session:Session };


                   this.$http.jsonp(removeMainMenu, {params: para}).then(
                   function(res){                         
                         if (res.data.result_code==200)
                         {
							this.listLoading = false;
							this.$message({
							message: '删除成功',
							type: 'success'
						    });
							this.getMenus();
                           
                         }
                         else{                           
                                this.listLoading = false;
								if (res.data.result_code==911)
							  {
                                  this.$router.push({ path: "/login"});
								  return;
							  }

                              if (res.data.result_code==600)
							  {
									this.$message({
										message:'接口错误',
										type: 'error'
									});
                                  return;
							  }
							if  (res.data.result_code==914)
                            {
                              this.$message({
                                message:'没有删除权限',
                                type: 'error'
                              });
							   return;
							}
                         }
                       

                   },
                   function(res)
                   {
                        this.$message({
                                message:'接口访问失败',
                                type: 'error'
                              });
                     this.listLoading = false;
                   });


				}
				
				).catch(() => {

				});
			},
			//显示编辑界面
			handleEdit: function (index, row) {
				
				this.formStatus=1;
				this.editFormVisible = true;
				this.editForm = Object.assign({}, row);
            
				if (this.$refs['editForm'] !== undefined) {						
                    this.$refs['editForm'].resetFields();
                }
				
			},
			//显示新增界面
			handleAdd: function () {
				
				this.formStatus=0;
				this.editFormVisible = true;
				if (this.$refs['editForm'] !== undefined) {						
                    this.$refs['editForm'].resetFields();
                }
				this.editForm = {
					menu_id: 0,
					menu_name: '',
					menu_code: '',
					parent_code:'',
					icon:'',
					path: ''
				};

				
			},
			//编辑
			editSubmit: function () {
				this.$refs.editForm.validate((valid) => {
					if (valid) {
						this.$confirm('确认提交吗？', '提示', {}).then(() => {
							this.editLoading = true;
							//NProgress.start();
							let para = Object.assign({}, this.editForm);
							para["sys_type"] = "3";
							para["CurrentUserID"] = CurrentUserID;
							para["Session"]=Session;

			   let menuUrl=	addMainMenu;			  
               if (this.formStatus==1)
			   {
                  menuUrl=editMainMenu;
			   }
                this.$http.jsonp(menuUrl, {params: para}).then(
                   function(res){                         
                         if (res.data.result_code==200)
                         {
							    if (this.$refs['editForm'] !== undefined) {						
									this.$refs['editForm'].resetFields();
								}
							 	this.editLoading = false;								
								this.$message({
									message: '提交成功',
									type: 'success'
								});
								

								if (this.formStatus==1)
								{
								  this.editFormVisible = false;
								}
								this.getMenus();
								this.getParent();
                           
                         }
                         else{                           
                              this.editLoading = false;
							 if (res.data.result_code==911)
							  {
                                 this.$router.push({ path: "/login"});
								  return;
							  }

                              if (res.data.result_code==600)
							  {
									this.$message({
										message:'接口错误',
										type: 'error'
									});
                                  return;
							  }
							if  (res.data.result_code==912)
                            {
                              this.$message({
                                message:'没有新增权限',
                                type: 'error'
                              });
							   return;
							}
							if  (res.data.result_code==913)
                            {
                              this.$message({
                                message:'没有编辑权限',
                                type: 'error'
                              });
							   return;
							}
                         }
                       

                   },
                   function(res)
                   {
                        this.$message({
                                message:'接口访问失败',
                                type: 'error'
                              });
                      this.editLoading = false;	
                   }
           )

						});
					}
				});
			},
			
			selsChange: function (sels) {
				this.sels = sels;
			},
			sortChange:function(order){
                   this.prop=order.prop;
				   this.order=order.order,
                 this.getMenus();
			},
			//批量删除
			batchRemove: function () {
				var ids = this.sels.map(item => item.menu_id).toString();
				this.$confirm('确认删除选中记录吗？', '提示', {
					type: 'warning'
				}).then(() => {
					this.listLoading = true;
					//NProgress.start();
					let para = { ids: ids,CurrentUserID:CurrentUserID,sys_type:3,Session:Session };


                   this.$http.jsonp(batchRemoveMainMenu, {params: para}).then(
                   function(res){                         
                         if (res.data.result_code==200)
                         {
							this.listLoading = false;
							this.$message({
							message: '删除成功',
							type: 'success'
						    });
							this.getMenus();
                           
                         }
                         else{                           
                               this.listLoading = false;
							  if (res.data.result_code==911)
							  {
                                  this.$router.push({ path: "/login"});
								  return;
							  }

                              if (res.data.result_code==600)
							  {
									this.$message({
										message:'接口错误',
										type: 'error'
									});
                                  return;
							  }
							if  (res.data.result_code==914)
                            {
                              this.$message({
                                message:'没有删除权限',
                                type: 'error'
                              });
							   return;
							}
                         }
                       

                   },
                   function(res)
                   {
                        this.$message({
                                message:'接口访问失败',
                                type: 'error'
                              });
                      this.listLoading = false;
                   });


				}).catch(() => {

				});
			}
		},
		mounted() {
				CurrentUserID=sessionStorage.getItem('userID')==null?0:sessionStorage.getItem('userID'); 
                Session=sessionStorage.getItem('session')==null?0:sessionStorage.getItem('session'); 
			this.getMenus();
			this.getParent();
			this.$http.jsonp(getSysMenu,{params: {CurrentUserID:CurrentUserID,SysType:3,Session:Session}}).then(
			function(res){                         
					if (res.data.result_code==200)
					{						
						this.options=res.data.menus;					
					}
					else{                           
						this.$message({
						message:'获取菜单错误',
						type: 'error'
						});

					
					}				

			},
			function(res)
			{
				this.$message({
						message:'获取菜单错误',
						type: 'error'
						});
				
			});
		}
	}

</script>

<style scoped>
  .el_input_width{
	 width:220px; 
  }
</style>


// WEBPACK FOOTER //
// mainmenu.vue?31c96e92